import RichText from '../RichText';
import SingleLineText from '../SingleLineText';

const defaultProps = {
	title: SingleLineText.DefaultProps,
	description: RichText.DefaultProps,
};

export default defaultProps;
